var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('core-app-bar'),_c('core-drawer',{attrs:{"image":_vm.bgMenu,"logo":_vm.logo,"links":_vm.menu}}),_c('core-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }